import styles from "./Title.module.scss";

export default function Title ({ children, style }) {
  return (
    <h1 style={style ? style : {}} className={styles.title}>{ children }</h1>
  );
}
